import { FunctionComponent, SVGProps } from 'react';
import { Device } from 'common/device';
import './Header.css';
import Svgs from 'assets/svgs';
import { useQuery } from 'hooks/useQuery';

interface HeaderBtnProps {
    svg?: FunctionComponent<SVGProps<SVGSVGElement>>;
    func?: () => void
}

interface HeaderProps {
    title: string,
    leftBtn?: HeaderBtnProps,
    rightBtn?: HeaderBtnProps,
    isBack?: boolean
}

export const Header = ({ title, leftBtn, rightBtn, isBack }: HeaderProps) => {
    const { navigate } = useQuery();
    const defaultInset = {
        statusBarHeight : 0,
        navigationBarHeight : 0
    }
    const inset = window.__DEVICE__?.inset ?? defaultInset;

    const buttonRender = (btn: HeaderBtnProps) => {
        const IconComponent = btn.svg;
        if(IconComponent && btn.func) {
            return (
                <div className="header_btn_wrapper" onClick={btn.func}>
                    <IconComponent />
                </div>
            )
        } else return <div className="header_btn_wrapper"></div>
    }

    return (
        <>
            <div className="header_wrapper" style={{ paddingTop: inset?.statusBarHeight }}>
                <div className='header_container'>
                    {isBack ? buttonRender({svg: Svgs.IcBack24, func: () => navigate(-1)}) :
                        buttonRender(leftBtn || {})
                    }
                    <span className='header_title'>{title}</span>
                    {buttonRender(rightBtn || {})}
                </div>
            </div>
            <div className="header_padding" style={{height: 54 + inset?.statusBarHeight}}></div>
        </>
    )
}